import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

import { getUserLocation } from "../../redux";
import { useGetAllEmployeeData } from "../../hooks";
import { EmployeesTable } from "../../tables";
import { PageContent } from "../../components";
import { CreateEmployeeDialog, EditEmployeeDialog } from "../../dialogs";

import EmployeesBar from "./EmployeesBar";
import EmployeeSheet from "./EmployeeSheet";
import { useHandleMultiPageDownload } from "../../helpers";

export const Employees = ({ defaultLocation = 1 }) => {
  const { search } = useLocation();
  const { isLoading, refetch } = useGetAllEmployeeData({ defaultLocation });
  const [id, setOpen] = useState(null);

  useEffect(() => {
    refetch();
  }, [search?.toString()]);

  const name = "employee-sheet";
  const handleDownload = useHandleMultiPageDownload({ name, flip: true });

  const props = { id, setOpen, defaultLocation };

  return (
    <PageContent gap="10px" isLoading={isLoading} smallPadding hideOverflow>
      <EmployeesBar {...props} handleDownload={handleDownload} />
      <EmployeesTable {...props} />
      <EmployeeSheet {...props} />
      <EditEmployeeDialog {...props} />
      <CreateEmployeeDialog />
    </PageContent>
  );
};

const mapStateToProps = (state) => ({
  defaultLocation: getUserLocation(state),
});
export const EmployeesContainer = connect(mapStateToProps)(Employees);
export default EmployeesContainer;
